export default __webpack_public_path__ + "static/media/diabetes-set-healthy-food-blue-wall (1) (1) (1).db192cf1.jpg";